import { useMsal } from "@azure/msal-react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { loginRequest } from "../config/authConfig";
import { useTranslation } from "react-i18next";

export const LoginPage = () => {
    const {t} = useTranslation();
  const { instance } = useMsal();
  return (
    <Grid container>
      <Grid item xs={1} sm={2} md={2} lg={2} xl={4} />
      <Grid item xs={10} sm={8} md={8} lg={8} xl={4}>
        <Box mt={10}>
          <img
            alt="Precure logo"
            style={{
              width: "150px",
              height: "30px",
            }}
            src={
              "https://precure-cdn.azureedge.net/files/mli-interface/logos/precure_full.png"
            }
          />
        </Box>
        <Box width="100%">
          <Typography variant="h3">{t("signInPage.text1")}</Typography>
        </Box>
        <Box>
          <Typography variant="h3">MLI® Interface</Typography>
        </Box>
        <Box mt={1} width="90%">
          <Typography>{t("signInPage.text2")}</Typography>
        </Box>
        <Box mt={1}>
          <Button
            aria-label="Sign in"
            variant="contained"
            onClick={() => {
              instance.loginRedirect(loginRequest);
            }}
          >
            <Typography>{t("buttons.signIn")}</Typography>
          </Button>
        </Box>
      </Grid>
      <Grid item xs={1} sm={2} md={2} lg={2} xl={4} />
    </Grid>
  );
};

export default LoginPage;
